import { formattedDateTime } from '@epicuro-next/utilities';

const listTitleDateFormat = 'dd/MM/yyyy';

export function generateListName() {
  return `List ${formattedDateTime(new Date(), listTitleDateFormat)}`;
}
